"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSClaimComment_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSClaimComment_Factory = /** @class */ (function () {
    function NHSClaimComment_Factory() {
    }
    NHSClaimComment_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ClaimId: model.ClaimId,
            Comment: model.Comment,
            CommentDate: Date_Factory_1.Date_Factory.CreateIncoming(model.CommentDate),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    NHSClaimComment_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ClaimId: model.ClaimId,
            Comment: model.Comment,
            CommentDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.CommentDate),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return NHSClaimComment_Factory;
}());
exports.NHSClaimComment_Factory = NHSClaimComment_Factory;
